const MACHINE_MODEL_NAMES = {
  0: 'DT70', 1: 'DT100', 2: 'DT130', 3: 'DT160',
  4: 'DT70S', 5: 'DT100S', 6: 'DT160S',
  10: 'DT350', 11: 'DT520', 13: 'DT560', 14: 'DT650',
};

export const machineNameFromCombinedID = (combinedID) => {
  const normalized = String(combinedID || '').trim();
  if (!/^[0-9]{8}$/.test(normalized)) return '';
  const modelID = Number(normalized.slice(4, 6));
  const machineNo = Number(normalized.slice(6, 8));
  const modelName = MACHINE_MODEL_NAMES[modelID];
  return modelName ? `${modelName}_${machineNo}` : '';
};
